import React, { Component } from "react";
import { Modal } from "antd";
import PrintComponent from "../components/print";
import Resources from "../scripts/resources";
import PrintOrder from "../components/printOrder";

class PrintFactor extends Component {
  render() {
    const { data, onClose, visible } = this.props;
    return (
      <Modal
        title={Resources.print}
        visible={visible}
        onCancel={onClose}
        footer={false}
        width={1200}
        bodyStyle={{overflowX: 'scroll'}}
        style={{ height: 'calc(100vh - 150px)' }}
      >
        <PrintOrder printDetail={data} />
      </Modal>
    );
  }
}

export default PrintFactor;
